import { all } from 'redux-saga/effects';

import consultaMunicipiosSaga from './municipios/saga';
import consultaNaturalidadesSaga from './naturalidade/saga';

export default all([consultaMunicipiosSaga, consultaNaturalidadesSaga]);
